// export const SIGNUPPAGE_USERNAME = "SIGNUPPAGE_USERNAME";
// export const SETPASSWORD_SUBMIT = "SETPASSWORD_SUBMIT";
// export const SETPASSWORD_SUCCESS = "SETPASSWORD_SUCCESS";
export const SETPASSWORD_SUBMIT = "SETPASSWORD_SUBMIT";
export const SETPASSWORD_SUCCESS = "SETPASSWORD_SUCCESS";
export const SETPASSWORD_FAIL = "SETPASSWORD_FAIL";
